import React from "react";

export default function ThemeSettings({ darkMode, toggleDarkMode }) {
  return (
    <section className="bg-gray-50 dark:bg-gray-900 p-6 rounded-lg shadow-md max-w-xl mx-auto">
      <h3 className="text-2xl font-semibold mb-6 text-gray-900 dark:text-white">Theme Settings</h3>

      <div className="flex items-center space-x-4">
        <label htmlFor="darkModeToggle" className="text-gray-700 dark:text-gray-300 font-medium">
          Dark Mode
        </label>
        <input
          id="darkModeToggle"
          type="checkbox"
          checked={darkMode}
          onChange={toggleDarkMode}
          className="form-checkbox h-5 w-5 text-blue-600"
        />
      </div>
    </section>
  );
}
